import { handleActions, combineActions } from 'redux-actions'
import { fromJS } from 'immutable'

import * as Actions from 'actions/influencers'
import * as AppActions from 'actions/app'

export const initialState = fromJS({
  show: false,
  loading: false,
  influencerLoading: false,
  distributionListCreateDialogOpen: false
})

export default handleActions({
  [Actions.openAddInfluencerToContactsDialog]: state => state.set('show', true),
  [Actions.closeAddInfluencerToContactsDialog]: state => state.set('show', false),
  [Actions.setDistributionListCreateDialogOpen]: (state, { payload }) => state.set('distributionListCreateDialogOpen', payload),
  [Actions.addInfluencerToContactsStart]: state => state.set('loading', true),
  [Actions.addInfluencerToContactsError]: state => state.set('loading', false),
  [Actions.addInfluencerToContactsSuccess]: state => (
    state.set('loading', false)
      .set('distributionListCreateDialogOpen', false)
      .set('show', false)
  ),
  [Actions.fetchInfluencerStart]: state => state.set('influencerLoading', true),
  [combineActions(
    Actions.fetchInfluencerSuccess,
    Actions.fetchInfluencerError
  )]: state => state.set('influencerLoading', false),
  [AppActions.resetState]: () => initialState
}, initialState)
